import React, { useState } from 'react';
import Navbar from './component/Navbar';
import Footer from './component/Footer';

const TermConditions = () => {
  const [activeSection, setActiveSection] = useState('terms');

  const scrollToSection = (id) => {
    setActiveSection(id);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const sections = [
    { id: 'overview', title: '1. Electronic Record & Scope', icon: 'fas fa-file-contract' },
    { id: 'terms', title: '2. Terms of Use', icon: 'fas fa-balance-scale' },
    { id: 'services', title: '3. Platform & Delivery Services', icon: 'fas fa-layer-group' },
    { id: 'amendments', title: '4. Policy Modifications', icon: 'fas fa-edit' },
    { id: 'liability', title: '5. Intermediary Status & Liability', icon: 'fas fa-gavel' },
  ];

  return (
    <div style={{ backgroundColor: '#060816', color: '#FFFFFF', minHeight: '100vh', position: 'relative' }}>
      {/* Navigation Header */}
      <Navbar onOpenConsultation={() => (window.location.href = '/contact')} />

      {/* Main Content Area */}
      <main style={{ paddingTop: '78px', paddingBottom: '50px' }}>
        <div className="ht-container">
          {/* Hero Header Section */}
          <div className="section-header" style={{ textAlign: 'center', marginBottom: '24px' }}>
            <span
              style={{
                background: 'rgba(0, 212, 255, 0.12)',
                color: '#00D4FF',
                padding: '5px 14px',
                borderRadius: '20px',
                fontSize: '0.75rem',
                fontWeight: 800,
                letterSpacing: '1.2px',
                border: '1px solid rgba(0, 212, 255, 0.3)',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '12px',
              }}
            >
              <i className="fas fa-gavel"></i>
              <span>LEGAL AGREEMENT & TERMS</span>
            </span>

            <h1 className="text-gradient" style={{ fontSize: 'clamp(2rem, 3.5vw, 3rem)', fontWeight: 900, margin: '6px 0 10px 0', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Terms of Use & Service Agreement
            </h1>

            <p style={{ color: '#A3A8B8', fontSize: '1rem', maxWidth: '720px', margin: '0 auto 14px auto', lineHeight: 1.5, fontFamily: "'Inter', sans-serif" }}>
              These Terms of Use govern access to and usage of Hungry Top Technologies websites, software platforms, and mobile applications.
            </p>

            <span style={{ fontSize: '0.78rem', color: '#34D399', fontWeight: 700, background: 'rgba(52, 211, 153, 0.12)', padding: '3px 12px', borderRadius: '12px', border: '1px solid rgba(52, 211, 153, 0.3)' }}>
              Last Updated: June 2026 • IT Act 2000 Electronic Record
            </span>
          </div>

          {/* Table of Contents Section Nav */}
          <div
            style={{
              display: 'flex',
              gap: '8px',
              flexWrap: 'wrap',
              marginBottom: '24px',
              justifyContent: 'center',
            }}
          >
            {sections.map((sec) => (
              <button
                key={sec.id}
                onClick={() => scrollToSection(sec.id)}
                style={{
                  padding: '8px 18px',
                  borderRadius: '30px',
                  fontSize: '0.82rem',
                  fontWeight: 700,
                  whiteSpace: 'nowrap',
                  cursor: 'pointer',
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  border: activeSection === sec.id ? '1px solid rgba(0, 212, 255, 0.8)' : '1px solid rgba(255, 255, 255, 0.08)',
                  background: activeSection === sec.id ? 'linear-gradient(135deg, rgba(0, 212, 255, 0.25) 0%, rgba(108, 99, 255, 0.25) 100%)' : 'rgba(15, 23, 42, 0.7)',
                  color: activeSection === sec.id ? '#00D4FF' : '#94A3B8',
                  transition: 'all 0.25s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                }}
              >
                <i className={sec.icon} style={{ fontSize: '0.78rem' }}></i>
                <span>{sec.title}</span>
              </button>
            ))}
          </div>

          {/* Terms Content Container */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
            {/* Section 1: Scope */}
            <section
              id="overview"
              className="glass-card"
              style={{
                borderRadius: '24px',
                padding: '36px',
                background: 'rgba(15, 23, 42, 0.75)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: '38px', height: '38px', borderRadius: '12px', background: 'rgba(0, 212, 255, 0.15)', border: '1px solid rgba(0, 212, 255, 0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#00D4FF' }}>
                  <i className="fas fa-file-contract" style={{ fontSize: '1.1rem' }}></i>
                </div>
                <h2 style={{ fontSize: '1.4rem', color: '#FFF', fontWeight: 800, margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  1. Statutory Electronic Record & Applicability
                </h2>
              </div>

              <p style={{ color: '#CBD5E1', fontSize: '0.96rem', lineHeight: 1.75, marginBottom: '16px', fontFamily: "'Inter', sans-serif" }}>
                This document is an electronic record in terms of the Information Technology Act, 2000 and rules thereunder as applicable and the amended provisions pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000.
              </p>

              <p style={{ color: '#CBD5E1', fontSize: '0.96rem', lineHeight: 1.75, fontFamily: "'Inter', sans-serif" }}>
                This electronic document is published in accordance with Rule 3 (1) of the Information Technology (Intermediaries Guidelines) Rules, 2011 requiring publication of rules, regulations, privacy policy, and Terms of Use for access or usage of the <a href="https://www.hungrytop.com" style={{ color: '#00D4FF', textDecoration: 'none' }}>www.hungrytop.com</a> website and HungryTop mobile application.
              </p>
            </section>

            {/* Section 2: Terms of Use */}
            <section
              id="terms"
              className="glass-card"
              style={{
                borderRadius: '24px',
                padding: '36px',
                background: 'rgba(15, 23, 42, 0.75)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: '38px', height: '38px', borderRadius: '12px', background: 'rgba(108, 99, 255, 0.15)', border: '1px solid rgba(108, 99, 255, 0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#A78BFA' }}>
                  <i className="fas fa-balance-scale" style={{ fontSize: '1.1rem' }}></i>
                </div>
                <h2 style={{ fontSize: '1.4rem', color: '#FFF', fontWeight: 800, margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  2. Terms of Use & Corporate Structure
                </h2>
              </div>

              <p style={{ color: '#CBD5E1', fontSize: '0.96rem', lineHeight: 1.75, marginBottom: '16px', fontFamily: "'Inter', sans-serif" }}>
                The Platform is owned and operated by <strong>Hungry Top Technologies Limited</strong>, a corporate entity incorporated under the Companies Act, 1956 having its registered office at <strong>BL-5, PH-II, Golf Green Urban Complex, Kolkata - 700095, West Bengal, India</strong>.
              </p>

              <div style={{ background: 'rgba(108, 99, 255, 0.1)', padding: '20px', borderRadius: '16px', border: '1px solid rgba(108, 99, 255, 0.3)', marginTop: '20px' }}>
                <span style={{ color: '#A78BFA', fontWeight: 800, fontSize: '0.88rem', textTransform: 'uppercase', display: 'block', marginBottom: '6px', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  ⚖️ Contractual Binding Agreement
                </span>
                <p style={{ color: '#E2E8F0', fontSize: '0.92rem', margin: 0, lineHeight: 1.6 }}>
                  By installing, downloading, or using the Platform, you contract with HungryTop and signify acceptance of these Terms of Use, Privacy Policy, and Cancellation & Refund Policies.
                </p>
              </div>
            </section>

            {/* Section 3: Platform Services */}
            <section
              id="services"
              className="glass-card"
              style={{
                borderRadius: '24px',
                padding: '36px',
                background: 'rgba(15, 23, 42, 0.75)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: '38px', height: '38px', borderRadius: '12px', background: 'rgba(52, 211, 153, 0.15)', border: '1px solid rgba(52, 211, 153, 0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#34D399' }}>
                  <i className="fas fa-layer-group" style={{ fontSize: '1.1rem' }}></i>
                </div>
                <h2 style={{ fontSize: '1.4rem', color: '#FFF', fontWeight: 800, margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  3. Platform & Intermediary Services
                </h2>
              </div>

              <ul style={{ paddingLeft: '20px', color: '#CBD5E1', fontSize: '0.94rem', lineHeight: 1.75 }}>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Intermediary Role:</strong> HungryTop operates as a digital technology platform connecting users, merchants, and independent delivery partners.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Independent Contractors:</strong> Pick-up and delivery partners (PDPs) act as independent principal-to-principal contractors.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Pricing & Commercial Terms:</strong> Product pricing and specific commercial terms are determined directly by participating merchants.
                </li>
              </ul>
            </section>

            {/* Section 4: Policy Modifications */}
            <section
              id="amendments"
              className="glass-card"
              style={{
                borderRadius: '24px',
                padding: '36px',
                background: 'rgba(15, 23, 42, 0.75)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: '38px', height: '38px', borderRadius: '12px', background: 'rgba(245, 158, 11, 0.15)', border: '1px solid rgba(245, 158, 11, 0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#F59E0B' }}>
                  <i className="fas fa-edit" style={{ fontSize: '1.1rem' }}></i>
                </div>
                <h2 style={{ fontSize: '1.4rem', color: '#FFF', fontWeight: 800, margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  4. Amendments & Modifications
                </h2>
              </div>

              <p style={{ color: '#CBD5E1', fontSize: '0.96rem', lineHeight: 1.75, fontFamily: "'Inter', sans-serif" }}>
                HungryTop reserves the right to modify or amend these Terms of Use at any time. Modified terms will be published on the Platform with immediate effect upon posting. Your continued use of the Platform signifies consent to modified terms.
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TermConditions;
